import { render, staticRenderFns } from "./bubbles.vue?vue&type=template&id=6fbc9179&lang=true&"
import script from "./bubbles.vue?vue&type=script&lang=js&"
export * from "./bubbles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports